import { PolicyBlocks } from "@/components/site/PolicyBlocks";
import { POLICY_TEXTS } from "@/content/policy-texts";
import type { Locale } from "@/lib/i18n";

// Texterna ligger ordagrant i src/content/policy-texts.ts (underlag 2026-09-28).
export function PrivacyPolicyContent({ locale }: { locale: Locale; showIntro?: boolean }) {
  return <PolicyBlocks blocks={POLICY_TEXTS.privacy[locale]} />;
}

export function TermsPolicyContent({ locale }: { locale: Locale; showIntro?: boolean }) {
  return <PolicyBlocks blocks={POLICY_TEXTS.terms[locale]} />;
}
